<template>
    <div class="insOpenManagement">
        <div class="search_container">
            <div class="search_left">
                <el-form size="mini" ref="form" class="search_Box" :inline="true" :model="insOpenManagementData">
                    <el-form-item label="院校名称">
                        <el-input v-model="insOpenManagementData.orgName" @change="getOrgList(1)" clearable placeholder="请输入院校名称"></el-input>
                    </el-form-item>
                    <el-form-item label="省份" class="mySelect">
                        <el-select v-model="insOpenManagementData.provinceId"  @change="getOrgList(1)" clearable placeholder="全部" style="width: 100px;">
                            <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机构类型" class="mySelect">
                        <el-select v-model="insOpenManagementData.orgTypeId" @change="getOrgList(1)" clearable placeholder="全部" style="width: 100px;">
                            <el-option v-for="item in OrgTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" class="mySelect">
                        <el-select v-model="insOpenManagementData.isClose" @change="getOrgList(1)" clearable placeholder="全部" style="width: 100px;">
                            <el-option v-for="item in StatusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary" size="mini" @click="getOrgList(1)">查询</el-button>
            </div>
            <div class="search_right">
                <div class="backBtn" @click="backBtn"><img class="backIcon" src="../../../assets/image/home/back.png" alt="">返回</div>
            </div>
        </div>
        <div class="comPractice_container">
            <div class="title_box">
                <div class="left_title">
                    <span class="planName">{{planInfoData.schemeName}}</span>
                </div>
                <div class="btn_box">
                    <el-button type="primary" size="mini" @click="openBtn('batch')">批量开通</el-button>
                    <el-button type="primary" size="mini" @click="disaBleBtn('batch')">批量停用</el-button>
                </div>
            </div>
            <basic-table v-loading="loading" :isCheckbox='true' ref="mangeBasicTable" @operation="operation" :tableHeader="orgTypeDisplayList" :tableData="tableData">
                <template slot-scope="data">
                    <el-button type="text" v-if="data.row.isClose" size="mini" @click="openBtn('single', data.row)">开通</el-button>
                    <el-button type="text" v-else size="mini" @click="disaBleBtn('single', data.row)">停用</el-button>
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="insOpenManagementData.limitSize" :page.sync="insOpenManagementData.pageNo" @currentChange="currentChange"></pagination>
        </div>
    </div>

</template>

<script>
import { orgTypeDisplayList } from '../globalData'
import fetch from '@/api/fetch'
export default {
    name: 'insOpenManagement',

    data() {
        return {
            insOpenManagementData: {
                schemeId: '',
                orgName: '',
                provinceId: '',
                orgTypeId: '',
                isClose: ''
            },
            pageNo: 1,
            limitSize: 10,
            total: 0,
            orgTypeDisplayList: orgTypeDisplayList,
            tableData: [],
            OrgTypeList: [],
            loading: false,
            StatusList: [
                { id: 0, name: '已开通', value: 0 },
                { id: 1, name: '已停用', value: 1 },
            ],
            provinceData: [],
            orgIdList: [] // 保存所有的Id
        };
    },
    props: {
        planInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        planInfoData() {
            return this.planInfo
        }
    },

    mounted() {
        this.insOpenManagementData.schemeId = this.planInfoData.id
        this.getProvinceList()
        this.getOrgTypeListUrl()
        this.getOrgList()
    },

    methods: {
        disaBleBtn(type, rowData) { // 停用
            if (type == 'batch') {
                if (this.orgIdList.length <= 0) {
                    this.$message.error('请选中批量停用的机构')
                } else {
                    this.disaBleFun(this.orgIdList, 1)
                    this.orgIdList = []
                    this.$refs.mangeBasicTable.$refs.basicTable.$parent.getClearSelect()

                }
            } else {
                // single
                this.disaBleFun(rowData.id, 0)
            }
        },
        openBtn(type, rowData) { // 开通

            if (type == 'batch') {
                if (this.orgIdList.length <= 0) {
                    this.$message.error('请选中批量开通机构')
                } else {
                    this.openFun(this.orgIdList, 1)
                    this.orgIdList = []
                    this.$refs.mangeBasicTable.$refs.basicTable.$parent.getClearSelect()


                }
            } else {
                // single
                this.openFun(rowData.id, 0)
            }
        },
        disaBleFun(data, type) {
            fetch.closeSignupApply({
                idList: type ? data : [data]
            }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getOrgList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        openFun(data, type) {
            fetch.openSignupApply({
                idList: type ? data : [data]
            }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getOrgList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        operation(type, rowData) {
            if (type == 'selectChange') {
                this.orgIdList = rowData.map(item => {
                    return item.id
                })
            }
        },
        getOrgList(page) {
            this.loading = true
            let orgStatusArr = {
                '0': '已开通',
                '1': '已停用'
            }
            fetch.signupApplyPageList({...this.insOpenManagementData, pageNo: page || this.pageNo, limitSize: this.limitSize}).then(res => {
                if (res.code == '0') {
                    this.tableData = res.data.records.map(item => {
                        return { ...item, orgTime: `${item.beginTime || ''} - ${item.endTime || ''}`, orgStatusText: orgStatusArr[item.orgStatus] }
                    })
                    this.loading = false
                    this.pageNo = res.data.current
                    this.limitSize = res.data.size
                    this.total = res.data.total
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        getOrgTypeListUrl() {
            fetch.getOrgTypeListUrl().then(res => {
                if (res.code == '0') {
                    this.OrgTypeList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getProvinceList() { // 省份下拉
            fetch.getProvinceList().then(res => {
                if (res.code == '0') {
                    this.provinceData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        backBtn() {
            this.$emit('changeActive', 0)
        },
        currentChange(val) {
            this.insOpenManagementData.limitSize = val.limit
            this.insOpenManagementData.pageNo = val.page
            this.getOrgList(this.insOpenManagementData.pageNo)
        },
    },
    components: {
        // BaseSearch: () => import('../../components/baseSearch.vue'),
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue')
    }
};
</script>

<style lang="scss" scoped>
.insOpenManagement {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 0 20px;
        box-sizing: border-box;

        .search_left {
            width: 75%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .search_Box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            /deep/.el-form-item {
                margin-bottom: 0;
            }
        }
        .search_right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 25%;
            height: 100%;
        }
        .backBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
        .backIcon {
            width: 40px;
            height: 30px;
        }
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .title_box {
        display: flex;
        height: 60px;
        justify-content: space-between;
        align-items: center;
        .left_title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 80%;
            height: 100%;
            .planName {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 10px;
                height: 30px;
                box-sizing: border-box;
                font-size: 14px;
                color: #606266;
            }
            .subjectName {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
                box-sizing: border-box;
                height: 30px;
                font-size: 14px;
                color: #606266;
            }
            .grade {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
                height: 30px;
                box-sizing: border-box;
                font-size: 14px;
                color: #606266;
            }
        }
        .btn_box {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            width: 20%;
            height: 100%;
        }
    }
    /deep/.searchBox {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .searchBox_left {
            width: 50%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .searchBox_right {
            width: 50%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
        .margin_box {
            margin-right: 5px;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
    .addPaperTestDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-top: 10px;
        }
    }

    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>